module.exports = __webpack_public_path__ + "static/media/armbeygja.b1221a2a.png";